const getFlavorSelectionQuantitiesPayload = (flavorsSelection) => {
    return Object.entries(flavorsSelection).map(([key, value]) => {
        return {
            qty: [value],
            selection_id: [Number(key)],
        };
    });
};
export const getBundleProductCartPayload = (itemId, flavorsSelection = {}) => {
    return [
        {
            id: itemId,
            quantities: Object.keys(flavorsSelection).length > 0 ? getFlavorSelectionQuantitiesPayload(flavorsSelection) : [],
            quantity: 0, // Nobody knows what this value stands for, but it's better to leave it hardcoded value zero
            value: Object.keys(flavorsSelection),
        },
    ];
};
//# sourceMappingURL=getBundleProductCartPayload.js.map